import { render, staticRenderFns } from "./MigrationSalaries.vue?vue&type=template&id=358186a2&scoped=true"
import script from "./MigrationSalaries.vue?vue&type=script&lang=js"
export * from "./MigrationSalaries.vue?vue&type=script&lang=js"
import style0 from "./MigrationSalaries.vue?vue&type=style&index=0&id=358186a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358186a2",
  null
  
)

export default component.exports